import Styled from "./index.styles";

/** 약관 이 전체페이지가 아닌 작게 표시되는 경우는 small을 사용하여 적장하게 작은 font-size로 사용할 수 있다. */
type MarkdownLayoutSize = "default" | "small";

export type { MarkdownLayoutSize };

/**
 * MD로 작성된 약관의 공통 스타일을 적용해주는 Wrapper 컴포넌트
 * - 이 컴포넌트를 씌우면 github의 markdown 뷰어와 동일한 스타일이 적용됨
 */
export default function MarkdownLayout({
  children,
  size,
  className,
}: {
  children: React.ReactNode;
  size?: MarkdownLayoutSize;
  className?: string;
}) {
  return (
    <Styled.gfmStyleWrapper
      size={size || "default"}
      className={`${className ? className : ""} markdown-terms-layout`}
    >
      <Styled.childrenContainer className="markdown-body">
        {children}
      </Styled.childrenContainer>
    </Styled.gfmStyleWrapper>
  );
}
